import request from '@/utils/request'
import {applicationName} from '@/utils/const.js'

export function query(){
  return request({
    url:applicationName+'/web/franchise',
    method:'get',
  })
}